import { Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ApartmentIcon from '@material-ui/icons/Apartment';
import React from 'react';
import { useSelector } from 'react-redux';
import CardMessage from '../../../components/CardMessage/CardMessage';
import { AppState } from '../../../store';
import { CondominiumReducerData } from '../../../store/reducers/condominiumReducer';
import PunchCardObservationsTableCard from './components/PunchCardObservationsTableCard';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContentContainer: {
      overflowX: 'hidden',
      display: 'flex',
      alignItems: 'start',
      overflowY: 'auto',
      margin: 0,
      width: '100%',
      height: 'calc(100vh - 152px)',
      padding: theme.spacing(1),

      [theme.breakpoints.down('sm')]: {
        flexDirection: 'row',
      },
    },
    lowerContainer: {
      [theme.breakpoints.down('sm')]: {
        paddingTop: '16px',
      },
    },
    contentMaxHeight: {
      height: '100%',
    },
    purpleShortcutCard: {
      position: 'relative',
      minWidth: '230px',
      height: '100%',
      flex: 1,
    },
    cardIconRight: {
      position: 'absolute',
      top: 20,
      right: -2,
      fontSize: 40,
    },
  }),
);

const PunchCardObservations: React.FC = () => {
  const classes = useStyles();

  const { condominiumSelected }: CondominiumReducerData = useSelector(
    (state: AppState) => state.condominiumReducer,
  );

  return (
    <>
      <Grid className={classes.mainContentContainer} spacing={2} container>
        {condominiumSelected ? (
          <>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={classes.contentMaxHeight}
            >
              <PunchCardObservationsTableCard />
            </Grid>
          </>
        ) : (
          <CardMessage
            icon={<ApartmentIcon style={{ fontSize: 130, opacity: 0.4 }} />}
            message="Selecione um condomínio"
          />
        )}
      </Grid>
    </>
  );
};

export default PunchCardObservations;
